import {
  Card,
  CardHeader,
  Typography,
  Button,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { useTheme } from "@emotion/react";
import { IoIosAddCircleOutline } from "react-icons/io";
import { useSelector } from "react-redux";
import { setDialog } from "../../../../../app/slices/supplierSlice";
import BannerForm from "../../form";
import { BiImport } from "react-icons/bi";

const SupplierHeader = () => {
  const _Supplier = useSelector((state) => state.supplier);
  const dispatch = useDispatch();

  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Card>
      <CardHeader
        sx={{
          flexWrap: "wrap",
          rowGap: 1.5,
          "& .MuiCardHeader-action": {
            m: 0,
            ...(smallScreen && { width: "100%" }),
          },
        }}
        title={
          <Typography variant="h4" component="div">
            الموردين
          </Typography>
        }
        avatar={<BiImport size={20} />}
        action={
          <Button
            fullWidth={smallScreen}
            variant="contained"
            color="primary"
            size="medium"
            startIcon={<IoIosAddCircleOutline />}
            onClick={() => dispatch(setDialog())}
          >
            إضافة مورد جديد
          </Button>
        }
      />
      {_Supplier.supplier.dialog ? <BannerForm /> : null}
    </Card>
  );
};

export default SupplierHeader;
